import * as React from 'react';
import * as Redux from 'react-redux';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import * as CONST from '../../../../constants/FieldsConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allMateriasAction,
  asignarEntCarMateriasAction,
  deleteEntCarMateriasAction,
} from '../MateriasAction';
import FormMaterias from './FormMaterias';

export function CustomTabPanel(props) {
  const { children, value, index, p, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: p ?? 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AsignarCarreras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);
  const materiasStore = Redux.useSelector((state) => state.materias);

  const activo = materiasStore.activo;

  const [value, setValue] = React.useState(0);
  const [idCarrera, setIdCarrera] = React.useState('');
  const [loadingSave, setLoadingSave] = React.useState(false);

  const [carreras, setCarreras] = React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const list = [];
    entCarrerasStore.all.forEach((el) => {
      const select = activo.carreras.find((c) => c.carrera.id === el.id);
      if (!select) list.push(el);
    });
    setCarreras(list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Materia">
          <Tab label="Informacion" {...a11yProps(0)} />
          <Tab label="Carreras" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <FormMaterias setOpenModalForm={(value) => setOpenModalForm(value)} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={1}>
          <LoadingWidget
            isLoading={loadingSave}
            text="Asignado la carrera a la materia...."
          />
          <Grid item xs={8} md={8}>
            <FormControl fullWidth size="small">
              <InputLabel id={`label_${CONST.carrera.name}`}>
                {CONST.carrera.label}
              </InputLabel>
              <Select
                id={CONST.carrera.name}
                value={idCarrera}
                labelId={`label_${CONST.carrera.name}`}
                label={CONST.carrera.label}
                onChange={(e) => setIdCarrera(Number(e.target.value))}
              >
                {carreras.map((el, index) => {
                  return (
                    <MenuItem key={`carrera-${index}`} value={el.id}>
                      {el.carrera.nombre} ({el.modalidad})
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} md={4}>
            <BotonComponent
              disabled={idCarrera === null || idCarrera === 0}
              click={async () => {
                setLoadingSave(true);
                await asignarEntCarMateriasAction(
                  { dispatch, notify },
                  {
                    idCarrera,
                    idMateria: materiasStore.activo.id,
                  },
                );
                setIdCarrera('');
                setLoadingSave(false);
                allMateriasAction(dispatch, materiasStore.params);
              }}
              text="AGREGAR"
              blue
              addIcon
            />
          </Grid>
          <Grid item md={12}>
            <Box sx={{ minWidth: '800px' }}>
              <TableContainer>
                <Table
                  sx={{ width: '100%' }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell width="40%">Carrera</TableCell>
                      <TableCell width="30%">Modalidad</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {activo.carreras.map((el, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell width="40%" component="th">
                          {el.carrera.carrera.nombre}
                        </TableCell>
                        <TableCell width="30%" component="th">
                          {el.carrera.modalidad}
                        </TableCell>
                        <TableCell>
                          <BotonComponent
                            click={async () => {
                              setLoadingSave(true);
                              await deleteEntCarMateriasAction(
                                { dispatch, notify },
                                materiasStore.activo.id,
                                el.id,
                              );
                              setIdCarrera('');
                              setLoadingSave(false);
                              allMateriasAction(dispatch, materiasStore.params);
                            }}
                            text="ELIMINAR"
                            red
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </CustomTabPanel>
    </Box>
  );
};

export default AsignarCarreras;
